import React from 'react';
import EmptyPage from '../EmptyPage';

const FavoritesPage: React.FC = () => {
  return (
    <EmptyPage
      title="즐겨찾기"
      icon="Star"
      description="자주 사용하는 기능과 즐겨찾는 항목들을 관리합니다."
      parentTitle="대시보드"
    />
  );
};

export default FavoritesPage;
